import moment from "moment";

/**
 * Hasta 2026 el cierre se guardaba una hora adelantado: se escribia 18:00 para
 * que la convocatoria cerrara a las 17:00, y cada pantalla le restaba una hora
 * al mostrarlo o al validarlo. Desde 2027 el cronograma guarda la hora real,
 * asi que la resta solo aplica al dato viejo.
 *
 * Por eso la regla mira dos cosas: el anio y que la hora guardada sea 18. Una
 * convocatoria de 2026 que ya quedo guardada con las 17:00 no se toca.
 */
export const ULTIMO_ANIO_HORA_ADELANTADA = 2026;
export const HORA_GUARDADA_ADELANTADA = 18;

type ValorFecha = string | Date | moment.Moment | null | undefined;

/** Indica si el valormax recibido trae la hora adelantada del esquema viejo. */
export const cierreVieneAdelantado = (valormax: ValorFecha): boolean => {
  if (!valormax) return false;
  const m = moment(valormax);
  if (!m.isValid()) return false;
  return m.year() <= ULTIMO_ANIO_HORA_ADELANTADA && m.hours() === HORA_GUARDADA_ADELANTADA;
};

/** La hora real de cierre, como moment. Los minutos se conservan. */
export const momentCierre = (valormax: ValorFecha): moment.Moment => {
  const m = moment(valormax);
  return cierreVieneAdelantado(valormax) ? m.subtract(1, "hours") : m;
};

/** La hora real de cierre, como Date, para el codigo que no usa moment. */
export const fechaCierre = (valormax: ValorFecha): Date => momentCierre(valormax).toDate();
